import { render, staticRenderFns } from "./VeJwJingsaiGroupModal.vue?vue&type=template&id=7832dca6"
import script from "./VeJwJingsaiGroupModal.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports